import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
    vi: {
        translation: {
            "app": {
                "title": "Xóa Nền",
                "subtitle": "STUDIO PRO"
            },
            "upload": {
                "individual": "Ảnh lẻ",
                "folder": "Thư mục",
                "drop_images": "Thả ảnh vào đây",
                "choose_folder": "Chọn thư mục",
                "no_images_found": "Không tìm thấy ảnh hợp lệ trong thư mục",
                "intake_queue": "Hàng đợi nạp",
                "production_queue": "Tải lên",
                "ready_to_review": "Sẵn sàng kiểm duyệt",
                "waiting_renders": "Đang chờ AI xử lý...",
                "pipeline_empty": "Đường ống trống"
            },
            "inspector": {
                "ready_for_production": "Sẵn sàng sản xuất",
                "select_to_start": "Chọn một ảnh từ hàng đợi để bắt đầu chỉnh sửa",
                "rendering": "Đang render giao diện Studio...",
                "before": "Trước",
                "after": "Sau"
            },
            "controls": {
                "bg_type": "Loại nền",
                "transparent": "Trong suốt",
                "color": "Màu sắc",
                "scene": "Bối cảnh",
                "blur": "Độ mờ",
                "upload_scene": "Tải bối cảnh",
                "supported_formats": "Hỗ trợ JPEG, PNG",
                "custom_color": "Màu tùy chỉnh"
            },
            "actions": {
                "approve": "Duyệt",
                "reprocess": "Làm lại",
                "edit": "Chỉnh sửa thủ công",
                "export_zip": "Xuất file ZIP",
                "return_to_queue": "Đưa lại về hàng đợi",
                "download": "Tải xuống",
                "clear_all": "Xóa tất cả"
            },
            "status": {
                "pending": "Chờ xử lý",
                "processing": "Đang xử lý",
                "done": "Đã xong",
                "approved": "Đã duyệt",
                "approved_artifact": "Thành phẩm"
            },
            "model": {
                "gpu_fast": "RMBG 1.4 Nhanh",
                "modnet_gpu": "MODNet GPU",
                "engine_error": "Lỗi động cơ AI"
            },
            "edit_modal": {
                "title": "Chỉnh sửa vết cắt",
                "canvas": "Vùng làm việc",
                "brushes": "Cọ vẽ",
                "restore": "Khôi phục",
                "erase": "Xóa",
                "brush_size": "Kích thước cọ",
                "render_output": "Kết quả Render",
                "save_changes": "Lưu thay đổi",
                "cancel": "Hủy"
            }
        }
    },
    en: {
        translation: {
            "app": {
                "title": "AI BG",
                "subtitle": "STUDIO PRO"
            },
            "upload": {
                "individual": "Individual",
                "folder": "Batch Folder",
                "drop_images": "Drop Images",
                "choose_folder": "Choose Folder",
                "no_images_found": "No valid images found in the selected folder",
                "intake_queue": "Intake Queue",
                "production_queue": "Production Queue",
                "ready_to_review": "Ready to Review",
                "waiting_renders": "Awaiting finished renders...",
                "pipeline_empty": "Empty Pipeline"
            },
            "inspector": {
                "ready_for_production": "Ready for Production",
                "select_to_start": "Select an image from the queue to start fine-tuning",
                "rendering": "Rendering Studio View...",
                "before": "Before",
                "after": "After"
            },
            "controls": {
                "bg_type": "Background Type",
                "transparent": "Trans",
                "color": "Color",
                "scene": "Scene",
                "blur": "Blur",
                "upload_scene": "Upload Scene",
                "supported_formats": "JPEG, PNG supported",
                "custom_color": "Custom Color"
            },
            "actions": {
                "approve": "Approve",
                "reprocess": "Reprocess",
                "edit": "Manual Brush Edit",
                "export_zip": "Export Finished ZIP",
                "return_to_queue": "Return to Queue",
                "download": "Download",
                "clear_all": "Clear all"
            },
            "status": {
                "pending": "Pending",
                "processing": "Processing",
                "done": "Done",
                "approved": "Approved",
                "approved_artifact": "Approved Artifact"
            },
            "model": {
                "gpu_fast": "RMBG 1.4 Fast",
                "modnet_gpu": "MODNet GPU",
                "engine_error": "Engine error"
            },
            "edit_modal": {
                "title": "Edit Cutout",
                "canvas": "Canvas",
                "brushes": "Brushes",
                "restore": "Restore",
                "erase": "Erase",
                "brush_size": "Brush Size",
                "render_output": "Render Output",
                "save_changes": "Save Changes",
                "cancel": "Cancel"
            }
        }
    }
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: 'vi', // Force Vietnamese as default
        fallbackLng: 'vi',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
